"use strict";

export default angular.module("LinkService", []).factory("Links", [
  "$http",
  "$rootScope",
  "Flash",
  function($http, $rootScope, Flash) {
    var aliases = {};

    var api_prefix = '';

    function loadLinksFromDatabase(callback, search) {
      const system = search.codesystem;
      const code = search.code;

      const url = api_prefix + "api/links?codesystem=" + system + "&code=" + code;
      $http
        .get(url)
        .success(function(data) {
          callback(data);
        })
        .error(function(data) {
          Flash.error("Error getting links");
          callback(data);
        });
    }

    // Saves new link information in database
    function saveModifiedLink(newLink, callback) {
      $http
        .put(
          api_prefix + "api/links/" + encodeURIComponent(newLink.ID),
          newLink
        )
        .success(function(data, status) {
          Flash.create("success", "Link edited successfully");
          callback(status, true);
        })
        .error(function(data, status) {
          Flash.create("warning", "Error editing link, status: " + status);
          callback(status, false);
        });
    }

    function loadAliasesFromDatabase(callback) {
      $http
        .get(api_prefix + "api/links/aliases")
        .success(function(data, status) {
          console.log('🚀 ~ .success ~ data:', data)
          aliases = data;
          callback(status, true);
        })
        .error(function(data, status) {
          callback(status, false);
        });
    }

    // Returns the stored aliases for controllers
    function getAliases() {
      return aliases;
    }

    function postNewLink(linkDetails, callback) {
      $http
        .post(api_prefix + "api/links/", linkDetails)
        .success(function(data, status) {
          Flash.create("success", "Link saved successfully");
          callback(status, true, data);
        })
        .error(function(data, status) {
          Flash.create("warning", "Error saving link, status: " + status);
          callback(status, false, data);
        });
    }

    function deleteLink(linkID, callback) {
      $http
        .delete(api_prefix + "api/links/" + linkID)
        .success(function(data, status) {
          Flash.create("success", "Link deleted successfully");
          callback(status, true);
        })
        .error(function(data, status) {
          Flash.creates("warning", "Error deleting link, status: " + status);
          callback(status, false);
        });
    }

    function getCodesystems(callback) {
      $http
        .get(api_prefix + "api/codesystems")
        .success(function(data) {
          callback(data);
        })
        .error(function(data, status) {
          Flash.error("Error getting code systems: " + status);
          callback(data);
        });
    }

    return {
      loadLinksFromDatabase: loadLinksFromDatabase,
      saveModifiedLink: saveModifiedLink,
      loadAliasesFromDatabase: loadAliasesFromDatabase,
      getAliases: getAliases,
      postNewLink: postNewLink,
      deleteLink: deleteLink,
      getCodesystems: getCodesystems
    };
  }
]);
